import { combineReducers } from "redux";
import { routerReducer, RouterState } from "react-router-redux";
import {
  authenticationReducer,
  AuthenticationReducerType,
} from "../redux/authentication/authenticationReducer";
import {
  ChangePasswordReducerType,
  changePasswordReducer,
} from "redux/changePassword/changePasswordReducer";
import {
  PatientListReducerType,
  patientListReducer,
} from "redux/patients/patientList/patientListReducer";
import {
  PatientCSVReducerType,
  patientCSVReducer,
} from "redux/patients/downloadPatientCSV/downloadPatientCSVReducer";
import {
  DeletePatientReducerType,
  deletePatientReducer,
} from "redux/patients/deletePatient/deletePatientReducer";
import {
  ConsultationListReducerType,
  consultationListReducer,
} from "redux/consultations/consultationList/consultationListReducer";
import {
  ConsultationDetailsReducerType,
  consultationDetailsReducer,
} from "redux/consultations/consultationDetails/consultationDetailsReducer";
import {
  DownloadConsultationCSVReducerType,
  downloadConsultationCSVReducer,
} from "redux/consultations/downloadConsultationCSV/downloadConsultationCSVReducer";
import {
  ConsentStatementReducerType,
  consentStatementReducer,
} from "redux/consentStatement/getConsentStatement/getConsentStatementReducer";
import {
  PostConsentStatementReducerType,
  postConsentStatementReducer,
} from "redux/consentStatement/postConsentStatement/postConsentStatementReducer";
import {
  SettingInformationReducerType,
  settingInformationReducer,
} from "redux/setting/general/generalSettingReducer";
import {
  DefaultSettingReducerType,
  defaultSettingReducer,
} from "redux/setting/default/defaultSettingReducer";
import {
  VerifyPhoneNumberReducerType,
  verifyPhoneNumberReducer,
} from "redux/setting/verifyPhoneNumber/verifyPhoneNumberReducer";
import {
  PatientRegistrationReducerType,
  patientRegistrationReducer,
} from "redux/setting/patientRegistration/patientRegistrationReducer";
import {
  VerifyOTPReducerType,
  verifyOTPReducer,
} from "redux/setting/verifyOTP/verifyOTPReducer";
import {
  VoiceCallReducerType,
  voiceCallReducer,
} from "redux/setting/voiceCall/voiceCallReducer";
import {
  DashboardInfoReducerType,
  dashboardInfoReducer,
} from "redux/dashboard/dashboardInfo/dashboardInfoReducer";
import {
  SubscribeSuperCityReducerType,
  subscribeSuperCityReducer,
} from "redux/patients/subscribeSuperCity/subscribeSuperCityReducer";
import {
  activityListFilterReducer,
  ActivityFilterListReducerType,
} from "./messagemanagement/activitiesfilterlist/activitiesFilterListReducer";
import {
  classListFilterReducer,
  GetClassListFilterReducerType,
} from "./messagemanagement/classfilterlist/classFilterListReducer";
import {
  getStudentListReducer,
  GetStudentListReducerType,
} from "./messagemanagement/getstudentlist/getStudentListReducer";
import {
  temperatureListFilterReducer,
  GetTemperatureListFilterReducerType,
} from "./messagemanagement/temperaturefilterlist/temperatureFilterListReducer";
import {
  messageHistoryListReducer,
  MessageHistoryListReducerType,
} from "./messagemanagement/messagehistory/messageHistoryListReducer";
import {
  attendanceFilterListReducer,
  AttendanceFilterListReducerType,
} from "./messagemanagement/attendancefilterlist/attendanceFilterListReducer";
import {
  messageHistoryDetailReducer,
  MessageHistoryDetailReducerType,
} from "./messagemanagement/messagehistorydetail/messageHistoryDetailReducer";
import {
  sendMessageReducer,
  SendMessageReducerType,
} from "./messagemanagement/sendmessage/sendMessageReducer";
import {
  searchConditionReducer,
  SearchConditionReducerType,
} from "./messagemanagement/searchCondition/searchConditionReducer";
import {
  readHistoryListReducer,
  ReadHistoryListReducerType,
} from "./messagemanagement/readHistory/readHistoryListReducer";
import {
  PushNotificationReducerType,
  pushNotificationReducer,
} from "./messagemanagement/pushNotification/pushNotificationReducer";
import {
  UpdateMessageReducerType,
  updateMessageReducer,
} from "./messagemanagement/updateMessage/updateMessageReducer";
import {
  DeleteMessageReducerType,
  deleteMessageReducer,
} from "./messagemanagement/deleteMessage/deleteMessageReducer";
import {
  ResendMessageReducerType,
  resendMessageReducer,
} from "./messagemanagement/resendMessage/resendMessageReducer";
import {
  forgotPasswordReducer,
  ForgotPasswordReducerType,
} from "../redux/forgotpassword/forgotpasswordReducer";
import {
  resetPasswordReducer,
  ResetPasswordReducerType,
} from "../redux/resetpassword/resetpasswordReducer";
import {
  verifyResetPasswordTokenReducer,
  VerifyResetPasswordTokenReducerType,
} from "../redux/verifyResetPasswordToken/verifyResetPasswordTokenReducer";

export interface RootState {
  loginForm: AuthenticationReducerType;
  changePassword: ChangePasswordReducerType;
  patientList: PatientListReducerType;
  patientCSV: PatientCSVReducerType;
  deletePatient: DeletePatientReducerType;
  consultationList: ConsultationListReducerType;
  consultationDetails: ConsultationDetailsReducerType;
  downloadConsultationCSV: DownloadConsultationCSVReducerType;
  consentStatement: ConsentStatementReducerType;
  postConsentStatement: PostConsentStatementReducerType;
  settingInformation: SettingInformationReducerType;
  defaultSetting: DefaultSettingReducerType;
  verifyPhoneNumber: VerifyPhoneNumberReducerType;
  patientRegistration: PatientRegistrationReducerType;
  verifyOTP: VerifyOTPReducerType;
  voiceCall: VoiceCallReducerType;
  dashboardInfo: DashboardInfoReducerType;
  subscribeSuperCity: SubscribeSuperCityReducerType;
  activitiesListFilter: ActivityFilterListReducerType;
  classListFilter: GetClassListFilterReducerType;
  getStudentList: GetStudentListReducerType;
  temperatureListFilter: GetTemperatureListFilterReducerType;
  messageHistoryList: MessageHistoryListReducerType;
  attendanceListFilter: AttendanceFilterListReducerType;
  messageHistoryDetail: MessageHistoryDetailReducerType;
  sendMessage: SendMessageReducerType;
  searchCondition: SearchConditionReducerType;
  readHistory: ReadHistoryListReducerType;
  pushNotification: PushNotificationReducerType;
  updateMessage: UpdateMessageReducerType;
  deleteMessage: DeleteMessageReducerType;
  resendMessage: ResendMessageReducerType;
  forgotPassword: ForgotPasswordReducerType;
  resetPassword: ResetPasswordReducerType;
  verifyResetPasswordToken: VerifyResetPasswordTokenReducerType;
  routerReducer: RouterState;
}

const appReducer = combineReducers({
  loginForm: authenticationReducer,
  changePassword: changePasswordReducer,
  patientList: patientListReducer,
  patientCSV: patientCSVReducer,
  deletePatient: deletePatientReducer,
  consultationList: consultationListReducer,
  consultationDetails: consultationDetailsReducer,
  downloadConsultationCSV: downloadConsultationCSVReducer,
  consentStatement: consentStatementReducer,
  postConsentStatement: postConsentStatementReducer,
  settingInformation: settingInformationReducer,
  defaultSetting: defaultSettingReducer,
  verifyPhoneNumber: verifyPhoneNumberReducer,
  patientRegistration: patientRegistrationReducer,
  verifyOTP: verifyOTPReducer,
  voiceCall: voiceCallReducer,
  dashboardInfo: dashboardInfoReducer,
  subscribeSuperCity: subscribeSuperCityReducer,
  activitiesListFilter: activityListFilterReducer,
  classListFilter: classListFilterReducer,
  getStudentList: getStudentListReducer,
  temperatureListFilter: temperatureListFilterReducer,
  messageHistoryList: messageHistoryListReducer,
  attendanceListFilter: attendanceFilterListReducer,
  messageHistoryDetail: messageHistoryDetailReducer,
  sendMessage: sendMessageReducer,
  searchCondition: searchConditionReducer,
  readHistory: readHistoryListReducer,
  pushNotification: pushNotificationReducer,
  updateMessage: updateMessageReducer,
  deleteMessage: deleteMessageReducer,
  resendMessage: resendMessageReducer,
  forgotPassword: forgotPasswordReducer,
  resetPassword: resetPasswordReducer,
  verifyResetPasswordToken: verifyResetPasswordTokenReducer,
  routerReducer,
});

export default (state: any, action: any) => {
  if (action.type === "LOGOUT") {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};
